import { trpc, TrpcOutputs } from '../../config/trpc';

type EarliestExpiryRate = TrpcOutputs['getEarliestExpiredRate'];
type UseEarliestExpiryRate = [EarliestExpiryRate, boolean, string?];
export const useEarliestExpiringRate = (rateImportId: number): UseEarliestExpiryRate => {
  const { data, isLoading, error } = trpc.getEarliestExpiredRate.useQuery({
    rateImportId,
  });

  return [data, isLoading, error?.message];
};
